import Menu from "./modules/menu";
import Theme from "./modules/theme";
import Slider from "./modules/slider";
import ToTop from "./modules/toTop";
import Faq from "./modules/faq";
import NumbersInput from "./modules/number";
import ShareProduct from "./modules/shareProduct";
import ShowMore from "./modules/showMore";
import HoverMenu from "./modules/hoverMenuItem";
import CartUpdate from "./modules/cartUpdate";
import LoginRegisterToggle from "./modules/myAccount";

Menu.init();
Theme.init();
Slider.init();
ToTop.init();
Faq.init();
NumbersInput.init();
ShareProduct.init();
ShowMore.init();
HoverMenu.init();
CartUpdate.init();
LoginRegisterToggle.init();